import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { FollowUpTutorialsList } from '@/follow-up-tutorials/FollowUpTutorialsList';

/**
 * `archive-follow_up_tut.php:12-32` — a bare post-grid loop.
 *
 * DIV-7 — NO page heading of any kind. Legacy's archive renders zero `<h1>`
 * and no page-header block (crawled as coordinator 993: `<h1` count 0). The
 * CPT's `plural` label is registered swapped
 * (`class-follow-up-tutorials.php:26-27` gives `'plural' => 'Follow-Up
 * Tutorial'`) and reaches only the invisible `<title>` and the RSS
 * `<link title>`, never the page. Adding a visible heading would be a new bug,
 * not parity — and no sibling route sets a document title either.
 *
 * DIV-8 — `?search_term=` is honoured with no input rendered.
 * `functions/tutorials-functions.php:14-16` copies `$_GET['search_term']` onto
 * WP's `s` for all three tutorial archives, and the populated archive renders
 * no control for it: `follow-up-tutorials-sidebar` carries no
 * `archive-search-widget`, unlike both sibling tutorial sidebars. Measured:
 * `?search_term=partner` -> 3 of 5 articles, `?search_term=zzzznomatch` -> 0.
 * The parameter is kept because it is the parity default and it is what makes
 * the empty state reachable.
 */
function FollowUpTutorialsArchive(): ReactElement {
  const { search_term } = Route.useSearch();

  return <FollowUpTutorialsList searchTerm={search_term} />;
}

export const Route = createFileRoute('/_app/follow-up-tutorials/')({
  component: FollowUpTutorialsArchive,
  // `search_term`, legacy's own parameter name and the one
  // `tutorials.index.tsx:12-16` already validates.
  validateSearch: (
    search: Record<string, unknown>,
  ): { search_term?: string } => ({
    search_term: search.search_term ? `${search.search_term}` : undefined,
  }),
});
